"use client"

import CardUI from "~/components/ui/card";
import Button from "~/components/ui/Button";
import type { BookDocument } from "~/types/docs/ebook-doucment";
import { useState } from "react";

export const BookCard = ({ book }: { book: BookDocument }) => {
      const [imgSrc, setImgSrc] = useState(book.thumbnail ?? "/icons/contact.webp");
    
  return (
    <CardUI variant="morph" className="flex flex-col md:flex-row" dir="rtl">
      <div className="flex w-full items-center justify-center md:w-1/3 md:p-5">
        <div
              className="flex items-center justify-center rounded-2xl w-full"
            >
              <img
                className="aspect-2/3 max-h-64 w-full max-w-40 rounded-lg object-cover shadow-md"
                src={imgSrc}
                alt={book.name}
                onError={() => setImgSrc("/icons/contact.webp")}
              />
            </div>
      </div>
      <CardUI.Body className="flex flex-1 flex-col px-4 py-5 md:w-2/3" dir="rtl">
        <CardUI.Title>
          <span className="inline truncate" title={book.name}>
            {book.name}
          </span>
        </CardUI.Title>
        <CardUI.Paragraph dir="auto" className="my-2 text-gray-400 line-clamp-6 text-sm">{book.description}</CardUI.Paragraph>

        {book.active && book.url && (
          <Button link={book.url} variant="sky" className="mt-auto">
            دریافت کتاب الکترونیک
          </Button>
        )}
      </CardUI.Body>
    </CardUI>
  );
};
